"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hruler = void 0;

var react_1 = __importDefault(require("react"));

var Hruler = function Hruler(_a) {
  var theme = _a.theme;
  return react_1["default"].createElement("hr", {
    className: "mt-3 mb-3 md:mt-5 md:mb-5 xl:mt-7 xl:mb-7 " + (theme ? theme.body.borderColor : 'border-gray-300')
  });
};

exports.Hruler = Hruler;